import { trackPendingApiRequest } from "../system/appRuntimeGate";

const bodyMethods = new Set<PropertyKey>(["json", "text", "blob", "arrayBuffer", "formData", "bytes"]);
const CLONE_METHOD = "clone";

/** Auch das Einlesen großer Antworten gehört zum laufenden API-Vorgang. Keine Kopie des Bodys. */
export function trackResponseBody(response: Response, method = "POST", signal?: AbortSignal | null): Response {
  return new Proxy(response, {
    get(target, key) {
      const value: unknown = Reflect.get(target, key, target);
      if (key === CLONE_METHOD) return () => trackResponseBody(target.clone(), method, signal);
      if (bodyMethods.has(key) && typeof value === "function") {
        return async (...args: unknown[]) => {
          const release = trackPendingApiRequest(method);
          try {
            signal?.throwIfAborted();
            const body = await Reflect.apply(value, target, args);
            signal?.throwIfAborted();
            return body;
          } finally { release(); }
        };
      }
      return typeof value === "function" ? value.bind(target) : value;
    },
  });
}
